// Atomic capabilities used to gate menu items and (later) routes/endpoints.
// Roles are mapped to a set of these in rolePermissions.ts — components should
// never compare against a role directly, only against a Permission.
export const Permission = {
  STUDENTS_VIEW: "students:view",
  STUDENTS_MANAGE: "students:manage", // Enquiries/Admissions, Directory, Promotion, Transfer Certificate
  STUDENTS_ATTENDANCE_MARK: "students:attendance:mark",

  FACULTY_VIEW: "faculty:view",
  FACULTY_MANAGE: "faculty:manage", // Add/List, Subject Assignment, Timetable
  FACULTY_ATTENDANCE_MARK: "faculty:attendance:mark",

  STAFF_VIEW: "staff:view",
  STAFF_MANAGE: "staff:manage", // Add/List
  STAFF_ATTENDANCE_MARK: "staff:attendance:mark",

  PERSONS_MANAGE: "persons:manage", // Add/Directory — standalone guardian/contact records

  FEES_VIEW: "fees:view", // view dues (Outstanding)
  FEES_RECEIPTS_VIEW: "fees:receipts:view", // Receipts - admin and student (own); not faculty
  FEES_MANAGE: "fees:manage", // manage tuition/transport/library/exam fee dues & payments
  FEES_PAYMENTS_VIEW_OWN: "fees:payments:view:own", // student's own online payment history

  TRANSPORT_VIEW: "transport:view",
  TRANSPORT_MANAGE: "transport:manage", // Routes & Schedule, Assignments

  LIBRARY_VIEW: "library:view",
  LIBRARY_MANAGE: "library:manage", // Catalog, Assignments

  CONFIG_ACADEMICS_MANAGE: "config:academics:manage", // Academic Years, Grades, Sections, Subjects
  TIMETABLE_MANAGE: "timetable:manage", // Academics → Timetable (admin; coordinator once that role exists)
  TIMETABLE_VIEW_OWN: "timetable:view:own", // My Timetable - a faculty's own week (not admin)

  LEAVE_APPLY_OWN: "leave:apply:own", // My Space → My Leave - faculty now, students later (not admin)
  LEAVE_MANAGE: "leave:manage", // Staff → Leave Requests: approve / reject
  SUBSTITUTIONS_VIEW_OWN: "substitutions:view:own", // My Space → My Substitutions (not admin)
  SUBSTITUTIONS_MANAGE: "substitutions:manage", // Staff → Substitutions: assign who covers a faculty on leave
  CONFIG_FEE_STRUCTURE_MANAGE: "config:fee-structure:manage", // Fee Categories & Structures
  USERS_MANAGE: "users:manage", // Users & Access
  CONFIG_SYSTEM_MANAGE: "config:system:manage", // Settings → System
  CONFIG_SCHOOL_MANAGE: "config:school:manage", // Settings → School Profile, Fees & Receipts

  ALERTS_MANAGE: "alerts:manage", // Due Alerts, Holiday/Event Alerts, (future) Announcements
} as const;

export type PermissionValue = (typeof Permission)[keyof typeof Permission];
